var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardPrefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71759 16.9082C7.33967 15.2865 9.96954 15.2864 11.5916 16.9082C13.2138 18.5304 13.2138 21.161 11.5916 22.7832C9.96951 24.4051 7.33971 24.4051 5.71759 22.7832C4.09544 21.161 4.09544 18.5304 5.71759 16.9082ZM17.409 16.9092C19.0311 15.287 21.6609 15.287 23.283 16.9092C24.9052 18.5313 24.9052 21.161 23.283 22.7832C21.6609 24.4054 19.0312 24.4054 17.409 22.7832C15.7869 21.161 15.7868 18.5313 17.409 16.9092ZM5.71661 5.2168C7.33877 3.59464 9.96848 3.59464 11.5906 5.2168C13.2128 6.83895 13.2128 9.46867 11.5906 11.0908C9.96849 12.713 7.33877 12.713 5.71661 11.0908C4.09446 9.46867 4.09446 6.83895 5.71661 5.2168ZM17.408 5.2168C19.0302 3.59464 21.6609 3.59464 23.283 5.2168C24.9048 6.83888 24.9048 9.46874 23.283 11.0908C21.6609 12.713 19.0302 12.713 17.408 11.0908C15.7861 9.46872 15.7861 6.8389 17.408 5.2168Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPrefill);
export default __webpack_public_path__ + "static/media/dashboardPrefill.ee446d1d3bc04ddf7795dd62473c928f.svg";
export { ForwardRef as ReactComponent };